import React from 'react';
import '../styles/Timeline.css';

import greyCard from '../assets/sentencesImages/cards/grey.png';
import blueCard from '../assets/sentencesImages/cards/blue.png';

export default function Timeline({ total = 14, current = 1, cards }) {
    return (
        <div className="timeline">
            <div className="timeline-line">
                {cards && Array.isArray(cards)
                    ? cards.map((cardSrc, index) => {
                        const cardNumber = index + 1;
                        return (
                            <img
                                key={index}
                                src={cardNumber <= current ? cardSrc : greyCard}
                                alt={`card-${cardNumber}`}
                                className="card"
                            />
                        );
                    })
                    : Array.from({ length: total }, (_, index) => {
                        const cardNumber = index + 1;
                        return (
                            <img
                                key={cardNumber}
                                src={cardNumber <= current ? blueCard : greyCard}
                                alt={`card-${cardNumber}`}
                                className="card"
                            />
                        );
                    })}
            </div>
        </div>
    );
}
